import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";

export class LoginCard extends React.Component {
  render() {
    const {
      loading,
      rememberMe,
      showPassword,
      email,
      password,
      handleSubmitFirebase,
      handleKeyPress,
      onInputChange,
      onCheckboxChange,
      toggleShowPassword
    } = this.props;

    return (
      <div className="login-page" onKeyPress={handleKeyPress}>
        <div className="ui-g">
          <div className="login-panel card">
            <div className="ui-g">
              <div
                className="ui-g-12"
                style={{ paddingTop: "25px !important" }}
              >
                <img
                  src="/assets/layout/images/business/color-logo.png"
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <div className="ui-g-12" style={{ paddingBottom: "0" }}>
                <hr />
                <center>
                  <b className="custom-label">Sign In</b>
                </center>
              </div>
              <div className="ui-g-12">
                <span className="md-inputfield form-field">
                  <pr.InputText
                    id="email"
                    value={email}
                    onChange={onInputChange}
                  />
                  <label htmlFor="email" className="imput-label">
                    Email Address
                  </label>
                </span>
              </div>
              <div className="ui-g-12" style={{ paddingBottom: "0" }}>
                <div className="ui-g-10" style={{ padding: 0 }}>
                  <span className="md-inputfield form-field">
                    {showPassword ? (
                      <pr.InputText
                        id="password"
                        value={password}
                        onChange={onInputChange}
                      />
                    ) : (
                      <pr.Password
                        id="password"
                        value={password || ""}
                        onChange={onInputChange}
                        feedback={false}
                        promptLabel="Strength"
                      />
                    )}
                    <label htmlFor="password" className="imput-label">
                      Password
                    </label>
                  </span>
                </div>
                <div className="ui-g-2">
                  <pr.Button
                    icon={showPassword ? "pi pi-eye-slash" : "pi pi-eye"}
                    onClick={toggleShowPassword}
                  />
                </div>
              </div>
              <div className="ui-g-12">
                <pr.Checkbox
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={e => {
                    e.id = "rememberMe";
                    onCheckboxChange(e);
                  }}
                />
                <label htmlFor="rememberMe" className="custom-label">
                  Remember Me
                </label>
              </div>
              <div className="ui-g-12">
                <pr.Button
                  label="Sign In"
                  icon={loading ? "pi pi-spin pi-spinner" : "pi pi-sign-in"}
                  onClick={handleSubmitFirebase}
                  style={{ width: "100%" }}
                />
                {/* <pr.Button
                  className="secondary-btn"
                  label="Register"
                  icon="pi pi-user-plus"
                  onClick={() => {
                    window.location = "#/register";
                  }}
                  style={{ width: "100%" }}
                /> */}
                <label>
                  By clicking Sign In, you agree to our Terms and have read and
                  acknowledged our Privacy Statement.
                </label>
                <br />
                <hr />
                <a href="#/password">I forgot my Password</a>
                <br />
                <hr />
                <label>
                  New to BPMBuild?{" "}
                  <a
                  //href="https://bpmbuild.typeform.com/to/Deu0su"
                  >
                    Register your business today
                  </a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/UI/LoginCard.js